import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { map } from "~/tools/rxjs";

import { typedStream } from "../../../../generic/redux/TypedRedux";
import type { RootState } from "../../RootState";

import { type TimestampUpdateSuccess, timestampAddedToHistory } from "./TimelineActions";
import { TIMESTAMP_UPDATE_SUCCESS } from "./TimelineActionTypes";

export const TimestampHistoryEpic: Epic<TimestampUpdateSuccess, AnyAction, RootState> = (actions) =>
	actions.pipe(
		typedStream(TIMESTAMP_UPDATE_SUCCESS),
		map(({ timestamp }) => timestampAddedToHistory(timestamp?.getTime())),
	);
